import {ButtonSaveFC, EnumPackageType} from "./types";
import useAlerts from "../../hooks/useAlerts";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router";
import {CreateErrors} from "../../store/invoice/create/types";
import {postInvoice} from "../../requests";
import {actionSetErrors} from "../../store/invoice/create/actions";
import Button from "@material-ui/core/Button";
import React from "react";
import {postInvoiceProducts} from "../../requests/invoice/item/post";
import {actionLoadingSuccessfully} from "../../store/invoice/detail/actions";

const ButtonSaveProducts: ButtonSaveFC = ({onSave, setSaving, saving}) => {
    const alerts = useAlerts();
    const {token, invoice} = useSelector(
        ({
             authToken: {token = ""},
             invoice: {
                 create: {invoice},
             },
         }) => ({invoice, token})
    );
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const handlerClick = () => {
        const errors: CreateErrors = {};
        const packageTypeKey = Object.keys(EnumPackageType).find((key) => EnumPackageType[key] === invoice.packageType);
        const packageType = packageTypeKey || '';
        if (
            !!invoice.vendor &&
            !!invoice.dateOfReceipt &&
            new Date(invoice.dateOfReceipt) >= new Date(new Date().toDateString()) &&
            !!invoice.number &&
            !!invoice.warehouse &&
            invoice.number.length > 0
        ) {
            setSaving(true);
            postInvoiceProducts(token, {
                vendorId: invoice.vendor.id,
                products: invoice.products,
                number: invoice.number,
                dateOfReceipt: invoice.dateOfReceipt.toDateString(),
                packageType: packageType.toLowerCase(),
                quantityPackages: Number(invoice.quantityPackages) > 0 ? invoice.quantityPackages : null,
                warehouseId: invoice.warehouse,
            })
                .then((response: any) => {
                    if (response.result === false) {
                        alerts({
                            variant: "error",
                            message: response.error,
                            autoHideDuration: 5000,
                        });
                    } else {
                        dispatch(actionLoadingSuccessfully(response));
                        onSave();
                        navigate("/invoice/" + response.id);
                    }
                })
                .catch(({message}: Error) => {
                    alerts({variant: "error", message});
                })
                .finally(() => {
                    setSaving(false);
                });
        } else if (
            !!invoice.vendor &&
            !!invoice.dateOfReceipt &&
            new Date(invoice.dateOfReceipt) >= new Date(new Date().toDateString()) &&
            !!invoice.number &&
            invoice.number.length > 0
        ) {
            setSaving(true);
            postInvoiceProducts(token, {
                vendorId: invoice.vendor.id,
                products: invoice.products,
                number: invoice.number,
                dateOfReceipt: invoice.dateOfReceipt.toDateString(),
                packageType: packageType.toLowerCase(),
                quantityPackages: Number(invoice.quantityPackages) > 0 ? invoice.quantityPackages : null,
            })
                .then((response: any) => {
                    if (response.result === false) {
                        alerts({
                            variant: "error",
                            message: response.error,
                            autoHideDuration: 5000,
                        });
                    } else {
                        dispatch(actionLoadingSuccessfully(response));
                        onSave();
                        navigate("/invoice/" + response.id);
                    }
                })
                .catch(({message}: Error) => {
                    alerts({variant: "error", message});
                })
                .finally(() => {
                    setSaving(false);
                });
        } else {
            if (!invoice.vendor) {
                errors.vendor = true;
            }
            // if (!invoice.file) {
            //   errors.file = true;
            // }
            if (!invoice.dateOfReceipt || new Date(invoice.dateOfReceipt) < new Date(new Date().toDateString()) ) {
                errors.dateOfReceipt = true;
            }
            if (!invoice.number) {
                errors.number = true;
            } else {
                if (invoice.number.length === 0) {
                    errors.number = true;
                }
            }
            if (!invoice.quantityPackages && (invoice.packageType === 'PALLET' || invoice.packageType === 'BOX') && Number(invoice.quantityPackages) > 0) {
                errors.quantityPackages = true;
            }
            if (Object.keys(errors).length > 0) {
                dispatch(actionSetErrors(errors));
            }
        }
    };
    return (
        <Button
            color={"primary"}
            disabled={saving}
            onClick={handlerClick}
            variant={"contained"}
        >
            {"Добавить"}
        </Button>
    );
};

export default ButtonSaveProducts;
